module.exports = {"protocol":"https://","domain":"capitaine-cles.fr","localStorageKey":"capitaine-cles"};


// WEBPACK FOOTER //
// external "{/"protocol/":/"https://",/"domain/":/"capitaine-cles.fr/",/"localStorageKey/":/"capitaine-cles/"}"